module.exports = __webpack_public_path__ + "static/media/qr-code-scan.27eb13fb.svg";